// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import "font-awesome/css/font-awesome.css"
import $ from 'jquery';
import Vue from 'vue';
import store from './store';
import App from './App';
import router from './router';
import common from './components/common';

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css';


import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VueAreaLinkage from 'vue-area-linkage'
import 'vue-area-linkage/dist/index.css';
Vue.use(VueAreaLinkage)


//注册全局过滤器
import filters from './filters';
Object.keys(filters).forEach(key=>{
  //console.log(key)
  Vue.filter(key,filters[key])
})

Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

Vue.use(common);

import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
//import './assets/css/swiper.min.css'

Vue.use(VueAwesomeSwiper, /* { default global options } */)

// 引入全局注册组件
import './components';


//mian.js中：google地图api
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
//填入申请的apiKey账号
    apiKey: 'AIzaSyDm6n6a_OHBN3JEXEqTw1Sti-cAiyQ1UxM',
    libraries: ['places'],
    useBetaRenderer: false,
  },
})

const IE11RouterFix = {
  methods: {
      hashChangeHandler: function() { this.$router.push(window.location.hash.substring(1, window.location.hash.length)); },
      isIE11: function() { return !!window.MSInputMethodContext && !!document.documentMode; }
  },
  mounted: function() { if ( this.isIE11() ) { window.addEventListener('hashchange', this.hashChangeHandler); } },
  destroyed: function() { if ( this.isIE11() ) { window.removeEventListener('hashchange', this.hashChangeHandler); } }
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mixins: [IE11RouterFix],
  activated(){
    
  },
  mounted(){
    this.setSize(); 
  },
  methods:{
      isTabRoute: function() {
        var that=this;
        $(window).scrollTop(0)
        
      }
  },
  
  watch: {
       '$route': 'isTabRoute',
  }
})


// WEBPACK FOOTER //
// ./src/main.js